import { Media } from "@Utilities/Media";
import { ReadMore } from "@Utilities/ReadMore";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import enquire from "enquire.js";

export class BaseCategory
{
	public FilterEl: HTMLElement;
	public DesktopFilterEl: HTMLElement;
	public MobileFilterEl: HTMLElement;
	public MobileFilterContainer: HTMLElement;
	public MobileFilterInstance: Offcanvas;
	public OffCanvasLibrary: Offcanvas;
	public RefreshTest = document.querySelector(".catRefresh") !== null;

	constructor()
	{
		const noResultsPage = (document.querySelector(".no-srch-rslt") !== null);
		const splitSearchPage = (document.querySelector(".split") !== null);

		if (!noResultsPage && !splitSearchPage)
		{
			this.Initialize();
		}
	}

	public Initialize(): void
	{
		this.CountTopRow();
		this.ConfigureFilter();
		this.ConfigureReadMore();

		enquire.register(Media.MediaMobile, {
			deferSetup: true,
			match: () =>
			{
				this.MobileFilterSetup();
				this.MobileSortSetup();
			},
			unmatch: () =>
			{
				this.MobileFilterDestroy();
				this.MobileSortDestroy();
			}
		});

		enquire.register(Media.MediaDesktop, {
			setup: () =>
			{
				document.querySelectorAll(".filter__header + .collapse").forEach((header) =>
				{
					header.classList.remove("d-lg-block");
					header.classList.add("show");
				});
			}
		});
	}

	public ConfigureFilter = (): void =>
	{
		this.FilterEl = document.getElementById("filter");
		this.DesktopFilterEl = document.getElementById("desktopFilter");
		this.MobileFilterEl = document.getElementById("mobileFilter");
		this.MobileFilterContainer = document.getElementById("offcanvasFilter");
		this.MobileFilterInstance = Offcanvas.getOrCreateInstance(this.MobileFilterContainer);
	};

	public ConfigureReadMore = (): void =>
	{
		const readClamp: NodeListOf<HTMLElement> = document.querySelectorAll(".readClamp");

		if (readClamp.length > 0)
		{
			readClamp.forEach(clamp =>
			{
				new ReadMore(clamp);
			});
		}
	};

	/// <summary>Counts the number of columns in the first row of products.</summary>
	public CountTopRow = (): void =>
	{
		let columns = 0;
		const resultsContainer = document.querySelector(".results");
		const currentCount = parseInt(resultsContainer.getAttribute("data-cols"), 10);
		const results = document.querySelectorAll(".results > div") as NodeListOf<HTMLElement>;

		if (results !== null && results.length > 0)
		{
			for (const column of results)
			{
				const previous = column.previousElementSibling as HTMLElement;

				if (previous !== null)
				{
					if (column.offsetTop !== previous.offsetTop)
					{
						break;
					}

					columns++;
				}

				else
				{
					columns++;
				}
			};
		}

		if (columns !== currentCount)
		{
			if (resultsContainer !== null)
			{
				resultsContainer.setAttribute("data-cols", columns.toString());
				this.AddFiller(columns);
			}
		}
	};

	public MobileFilterDestroy = (): void =>
	{
		this.DesktopFilterEl.innerHTML = this.FilterEl.outerHTML;
		this.MobileFilterEl.innerHTML = "";
		this.MobileFilterInstance.hide();

		document.querySelectorAll(".filter__header + .collapse").forEach((header) =>
		{
			header.classList.add("show");
		});
	};

	public MobileFilterSetup = (): void =>
	{
		this.MobileFilterEl.innerHTML = this.FilterEl.outerHTML;
		this.DesktopFilterEl.innerHTML = "";

		document.querySelectorAll(".filter__header + .collapse").forEach((header) =>
		{
			header.classList.remove("show");
		});
	};

	public MobileSortSetup = (): void =>
	{
	};

	public MobileSortDestroy = (): void =>
	{
	};

	public AddFiller(columns): void
	{
	};
}